import { cloudFunction } from 'services/parse';
import { DATE_FORMATS, formatDate } from 'utils';
import _ from 'lodash';

export const getReportForInventoryItemSale = (data: Record<string, any>) => {
  return cloudFunction('getReportForInventoryItemSale', data);
};

export const packerSpeedReport = (data: Record<string, any>) => {
  return cloudFunction('packerSpeedReport', data);
};

export const fetchRefundReport = async (data: Record<string, any>) => {
  const response = await cloudFunction('refundReport', data);
  return response.map(row => ({
    ...row,
    createdAt: formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
  }));
};

export const waitingForPaymentOrderReport = async (data: Record<string, any>) => {
  return cloudFunction('waitingForPaymentOrderReport', data);
};

export const orderSourceReport = (data: Record<string, any>) => {
  return cloudFunction('orderSourceReport', data);
};

export const getWeightedAvgCostReport = async (date: string) => {
  const response = await cloudFunction('getWeightedAvgCostReport', { date });
  return _.groupBy(response, 'categoryId');
};

export const sendWeightedAverageCostReport = async (date: string, emails: Array<string>) => {
  return await cloudFunction('sendWeightedAverageCostReport', { date, emails });
};

export const getSupplierInvoices = (data: Record<string, any>) => {
  return cloudFunction('supplierPOHistoryReport', data);
};

export const fetchDiscountRedemptionReport = (filter: Record<string, any>) => {
  return cloudFunction('fetchDiscountRedemptionReport', { filter });
};

export const specialDiscountReport = (filter: Record<string, any>) => {
  return cloudFunction('specialDiscountReport', { filter });
};

export const fetchItemReplenishmentReport = async (supplierId: string) => {
  const response = await cloudFunction('fetchInventoryItemReplenishmentReport', { supplierId });
  const groupedData = _.groupBy(response, (val) => val.week) as any;
  const tabularGroupData = Object.keys(groupedData).map(week => {
    groupedData[week] = groupedData[week].map(weeklyData => {
      weeklyData['totalPrice'] = weeklyData['quantity'] * weeklyData['inventoryItem']?.['price'];
      return weeklyData;
    });
    const totalPrice = _.sumBy(groupedData[week], (val: number) => val['totalPrice']);
    const totalQuantity = _.sumBy(groupedData[week], (val: number) => val['quantity']);
    const weekRange = groupedData[week]?.[0]?.['weekRange'];
    return {
      week,
      weekRange,
      weeklyData: groupedData[week],
      totalRows: groupedData[week].length,
      totalPrice,
      totalQuantity,
    };
  });
  return {
    groupData: tabularGroupData,
    rawData: response,
  };
};

export const salesChannelCountByInventoryItem = async () => {
  const response = await cloudFunction('salesChannelCountByInventoryItem', {});
  return response;
};